import { render, staticRenderFns } from "./BookingNewCalendar.vue?vue&type=template&id=b12d367a"
import script from "./BookingNewCalendar.vue?vue&type=script&lang=js"
export * from "./BookingNewCalendar.vue?vue&type=script&lang=js"
import style0 from "./BookingNewCalendar.vue?vue&type=style&index=0&id=b12d367a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports